import { config } from "config";
import { date } from "yup";

export default function NavbarBottom() {
  return (
    <>
      <footer className="footer pb-4">
        <div className="container d-flex flex-column align-items-center gap-3 text-white-50 small text-center">
          {/* Copyright */}
          <p className="mb-0">
            © {new Date().getFullYear()} <b>{config.appName}</b>, feito por{" "}
            <a
              href={config.made.company.website}
              target="_blank"
              rel="noopener noreferrer"
              className=""
            >
              {config.made.company.name}
            </a>
            .
            <br />
            Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </>
  );
}
